export const RSMOTO_MOTORCYCLE_CATEGORY_EXTERNAL_ID = 'rsmoto-motorcycles';
export const DEFAULT_RSMOTO_MOTORCYCLE_CATEGORY_ID = 391;

const rawMotorcycleCategoryId =
  process.env.NEXT_PUBLIC_RSMOTO_MOTORCYCLE_CATEGORY_ID?.trim() ||
  String(DEFAULT_RSMOTO_MOTORCYCLE_CATEGORY_ID);

export type RSMotoMotorcycleCategoryConfig =
  | { id: number; error: null }
  | { id: null; error: string };

/**
 * ID 391 was resolved from the imported `rsmoto-motorcycles` category on RS Moto.
 * Other environments can override it through deployment configuration.
 */
export function getRSMotoMotorcycleCategoryConfig(): RSMotoMotorcycleCategoryConfig {
  const id = Number(rawMotorcycleCategoryId);

  if (!Number.isInteger(id) || id <= 0) {
    return {
      id: null,
      error: 'NEXT_PUBLIC_RSMOTO_MOTORCYCLE_CATEGORY_ID musí byť kladné celé číslo.',
    };
  }

  return { id, error: null };
}
